import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginUser } from "../redux/user/userSlice";
import FieldIcon from "../utils/Register/field_icon";
import SendBtn from "../utils/Register/send_btn";
import conversion from "../assets/wito.png";
import backImage from "../assets/fondo.png";
import { FaUser, FaLock } from "react-icons/fa";

const SignInPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Credenciales inválidas");
      }

      const data = await response.json();

      dispatch(loginUser({ user: data.user, token: data.token }));
      navigate("/");
    } catch (error) {
      setError("Error al iniciar sesión: " + error.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div
        className="flex flex-col items-center bg-cover bg-center rounded-xl"
        style={{
          backgroundImage: `url(${backImage})`,
          maxWidth: "420px",
          padding: "0 5%",
          backgroundClip: "padding-box",
        }}
      >
        {/* Encabezado */}
        <div className="text-center text-white mb-8 mt-12">
          <h1 className="text-5xl font-bold">Hola</h1>
          <p className="text-lg mt-2">BIENVENIDO</p>
          <div className="flex justify-center mt-2">
            <img src={conversion} alt="Conversión" className="h-8" />
          </div>
        </div>

        {/* Formulario */}
        <div className="bg-white p-8 rounded-xl shadow-lg w-96">
          <h2 className="text-2xl font-bold text-center mb-6">
            Ingresa a tu cuenta
          </h2>
          <form onSubmit={handleSignIn}>
            {/* Campo de Correo */}
            <FieldIcon
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              placeholder="Introduce tu correo"
              value={email}
              required
              icon={<FaUser />}
              label="Correo"
              onChange={(e) => setEmail(e.target.value)}
            />

            <FieldIcon
              type="password"
              placeholder="Introduce tu contraseña"
              icon={<FaLock />}
              label="Contraseña"
              id="password"
              name="password"
              autoComplete="password"
              value={password}
              required
              onChange={(e) => setPassword(e.target.value)}
            />

            {/* Enlace de recuperación */}
            <div className="text-right mb-6">
              <a
                href="/forgot-password"
                className="text-sm text-blue-500 hover:underline"
              >
                ¿Olvidaste tu contraseña?
              </a>
            </div>

            {/* Botón de entrada */}
            <SendBtn
              label="Entrar"
              type="submit"
              style={{ backgroundColor: "#E5960E" }}
            />
            {error && <p className="text-red-500">{error}</p>}
          </form>

          {/* Registro */}
          <p className="text-center text-sm text-gray-700 mt-6">
            ¿No tienes una cuenta?{" "}
            <a href="/signup" className="text-blue-500 hover:underline">
              Regístrate
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;
